import CommonToggle from "../CommonToggle";

/**
 * @typedef {Object} CommonToggleCardProps
 * @property {string} heading - Main title text
 * @property {string} [subHeading] - Optional subtitle text
 * @property {boolean} state - Current toggle state
 * @property {boolean} isDisabled - Whether toggle is disabled
 * @property {(e: React.MouseEvent<HTMLButtonElement, MouseEvent>?) => void} handleClick - Function called when toggle is clicked
 */

/**
 * A reusable wrapper component that shows a heading, subheading, and a toggle on the right.
 * Fully responsive and matches the design of CommonToggle.
 *
 * @param {CommonToggleCardProps} props
 * @returns {JSX.Element}
 */
const CommonToggleCard = ({ description, state, isDisabled, handleClick }) => {
  return (
    <div
      className={`flex justify-between items-center w-full bg-primary-nav-act px-padding-md py-padding-sm rounded-border-radius-md shadow-sm `}
    >
      <div className="flex flex-col">
        <p className="text-text-primary text-font-md pr-padding-sm break-all whitespace-normal">
          {description}
        </p>
      </div>
      <div className="flex items-center">
        <CommonToggle
          state={state}
          isDisabled={isDisabled}
          handleClick={handleClick}
        />
      </div>
    </div>
  );
};

export default CommonToggleCard;
